import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useStoreState } from "app/state/store/hooks";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { getUrlParamsFromSelectedFilters } from "app/hooks/useUrlFilters";
import { ReactComponent as ChevronIcon } from "app/assets/vectors/BreadcrumbsChevron.svg";

interface BItem {
  title: string;
  link?: string;
}

interface BreadcrumbsProps {
  items: BItem[];
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = (
  props: BreadcrumbsProps
) => {
  const location = useLocation();
  const urlParams = useSearchParams()[0];

  const selectedFilters = useStoreState((state) => state.appliedFilters);

  const inActivityPage = React.useMemo(
    () => location.pathname.indexOf("/explorer/activities/") > -1,
    [location.pathname]
  );

  const locationSearch = React.useMemo(() => {
    if (location.search) {
      return location.search;
    }
    if (inActivityPage) {
      const queryString = decodeURIComponent(
        getUrlParamsFromSelectedFilters(selectedFilters, urlParams).toString()
      );
      return `${queryString.length > 0 ? "?" : ""}${queryString}`;
    }
    return "";
  }, [location.search, inActivityPage, selectedFilters, urlParams]);

  return (
    <Box
      sx={{
        gap: "10px",
        display: "flex",
        padding: "10px 0",
        alignItems: "center",
        flexDirection: "row",
        svg: {
          minWidth: "8px",
          minHeight: "8px",
        },
      }}
    >
      <Link to="/">
        <Typography variant="h6" fontSize="12px" fontWeight="400">
          Homepage
        </Typography>
      </Link>
      {props.items.length > 0 && <ChevronIcon />}
      {props.items.map((item, index) => (
        <React.Fragment key={item.title}>
          {item.link && index < props.items.length - 1 ? (
            <Link
              to={item.link + locationSearch}
              style={{
                textDecoration: "none",
              }}
            >
              <Typography variant="h6" fontSize="12px" fontWeight="400">
                {item.title}
              </Typography>
            </Link>
          ) : (
            <Typography
              variant="h6"
              fontSize="12px"
              fontWeight="400"
              sx={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {item.title}
            </Typography>
          )}
          {index < props.items.length - 1 && <ChevronIcon />}
        </React.Fragment>
      ))}
    </Box>
  );
};
